export const getBase64ImageByUrl = (
  url,
  format = 'image/jpeg',
  quality = 0.92
) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = url;
    image.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0);

      // Use the specified format and quality
      const dataURL =
        format === 'image/jpeg'
          ? canvas.toDataURL(format, quality)
          : canvas.toDataURL(format);

      const base64 = dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
      resolve(base64);
    };
    image.onerror = function () {
      reject();
    };
  });
};
